var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-file',_vm._g(_vm._b({attrs:{"drop-placeholder":"Drop here!","accept":"application/pdf, image/*, application/json","disabled":_vm.isReading},model:{value:(_vm.tempFile),callback:function ($$v) {_vm.tempFile=$$v},expression:"tempFile"}},'b-form-file',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62f74714","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FileReader.vue
// module id = null
// module chunks = 